/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import "./asset/sass/digital-journey/digital-journey.scss"
import App from "./App"
import ErrorBoundary from "./core/ErrorBoundary"
import * as serviceWorker from "./serviceWorker"
import * as setupConsoleLog from "./setupConsoleLog"
import React from "react"
import ReactDOM from "react-dom"
import { QueryClient, QueryClientProvider } from "react-query"
import { ReactQueryDevtools } from "react-query/devtools"

setupConsoleLog.consoleLogStrip()

const queryClient = new QueryClient()

ReactDOM.render(
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <App />
      {process.env.REACT_APP_ENV === "local" && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  </ErrorBoundary>,
  document.getElementById("root")
)
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
